// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__30xvt","content":"LayoutSettings_content__2W8Re"};